var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled, { css } from 'styled-components';
var DEFAULT_WIDTH = 100;
// Number display steps, in meters:
var STEPS = [
    1, 2, 3, 5, 10, 20, 30, 50, 100, 200, 300, 500, 1000, 2000, 3000, 5000, 10000,
    20000, 30000, 50000, 100000, 200000, 300000, 500000, 1000000, 2000000,
    3000000, 5000000
];
var ScaleControlBase = /** @class */ (function (_super) {
    __extends(ScaleControlBase, _super);
    function ScaleControlBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        //
        // Given a distance in meters, determine a rounded value.
        // 
        _this.getRoundedMeters = function (meters) {
            var current_diff = 999999999;
            var dist = 0;
            STEPS.forEach(function (step) {
                var diff = Math.abs(meters - step);
                if (diff < current_diff) {
                    current_diff = diff;
                    dist = step;
                }
            });
            return dist;
        };
        _this.formatNumber = function (num) {
            return num.toLocaleString(undefined, { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 });
        };
        //
        // Convert distance in meters to human-readable text (with units).
        //
        _this.getHumanText = function (meters) {
            if (meters >= 1000) {
                return "".concat(_this.formatNumber(meters / 1000), "km");
            }
            else {
                return "".concat(_this.formatNumber(meters), "m");
            }
        };
        _this.render = function () {
            var _a;
            var p = _this.props;
            var meterspx = 156543.03392 * Math.cos(p.latitude * Math.PI / 180) / Math.pow(2, p.zoom + 1);
            var width = (_a = p.width) !== null && _a !== void 0 ? _a : DEFAULT_WIDTH;
            var meters = width * meterspx;
            var dist = _this.getRoundedMeters(meters);
            width = width * dist / meters;
            return (React.createElement("div", { className: p.className, style: { width: "".concat(width, "px") } }, _this.getHumanText(dist)));
        };
        return _this;
    }
    return ScaleControlBase;
}(React.Component));
var ScaleControlStyled = styled(ScaleControlBase)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  /* Position */\n  position: absolute;\n  z-index: 100;\n  ", "\n  ", "\n  ", "\n  ", "  \n\n  /* Size */\n  box-sizing: border-box;\n  height: 20px;\n  padding-left: 5px;\n\n  /* Appearance */\n  border: solid 2px #333333;\n  border-top: none;\n  user-select: none;\n  pointer-events: none;\n  background: #C7C7C7;\n  font-size: 10px;\n  color: #333;\n  white-space: nowrap;\n  opacity: 0.8;\n  transition: width ease-in-out 100ms;\n"], ["\n  /* Position */\n  position: absolute;\n  z-index: 100;\n  ", "\n  ", "\n  ", "\n  ", "  \n\n  /* Size */\n  box-sizing: border-box;\n  height: 20px;\n  padding-left: 5px;\n\n  /* Appearance */\n  border: solid 2px #333333;\n  border-top: none;\n  user-select: none;\n  pointer-events: none;\n  background: #C7C7C7;\n  font-size: 10px;\n  color: #333;\n  white-space: nowrap;\n  opacity: 0.8;\n  transition: width ease-in-out 100ms;\n"
    /**
     * The `ScaleControl` shows a scale in meters per pixel.
     *
     * The control is positioned using `x` and `{y}`. Negative coordinates mean
     * offsets from right and bottom. A `width` may be provided, which defaults to
     * `100`.
     *
     * @example
     * ```tsx
     * <ScaleControl {...this.state.viewState} width={200} x={10} y={-62}/>
     * ```
     */
])), function (p) { return p.x >= 0 && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["left:   ", "px;"], ["left:   ", "px;"])), p.x); }, function (p) { return p.x < 0 && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["right:  ", "px;"], ["right:  ", "px;"])), -p.x); }, function (p) { return p.y >= 0 && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["top:    ", "px;"], ["top:    ", "px;"])), p.y); }, function (p) { return p.y < 0 && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["bottom: ", "px;"], ["bottom: ", "px;"])), -p.y); });
/**
 * The `ScaleControl` shows a scale in meters per pixel.
 *
 * The control is positioned using `x` and `{y}`. Negative coordinates mean
 * offsets from right and bottom. A `width` may be provided, which defaults to
 * `100`.
 *
 * @example
 * ```tsx
 * <ScaleControl {...this.state.viewState} width={200} x={10} y={-62}/>
 * ```
 */
var ScaleControl = function (p) { return React.createElement(ScaleControlStyled, __assign({}, p)); };
export { ScaleControl };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
